module.exports = __webpack_public_path__ + "static/chp-video-79b6e3fbefb9b7c7dc9b90184d719f6d.webm";